import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import SelectOption from "../../../../app/quick-add/sections/view/components/forms/common-blocks/select-option"
import getAvailableProjectsByViewType from "../../functions/get-available-projects"
import {EntityType} from "../../../gd/const/item";

enum ActivityGroupBy {
    DATE    = 'date',
    PROJECT = 'project',
    USER    = 'user',
}

type ActivityConditionsType = {
    projects        : ID[]
    defaultGroupBy  : ActivityGroupBy
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: ActivityConditionsType):void }
}

// const debug = "ViewActivity_Conditions"
const debug = false

export default function ViewActivity_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const conditions: ActivityConditionsType = {
            projects        : result.projects,
            defaultGroupBy  : result.defaultGroupBy || ActivityGroupBy.DATE,  //temp, for old views
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)

        onUserChange()
    }

    const conditions = props.view.settings

    const initFormData: any = {
        projects        : conditions?.projects || [],
        defaultGroupBy  : conditions?.defaultGroupBy || ActivityGroupBy.DATE,
    }

    const formStructure = {
        fields          : {
            projects            : { type: 'select',   isRequired: false,  label: 'Projects'},
            defaultGroupBy      : { type: 'select',   isRequired: false,  label: 'Default group by',        onUserChange: onUserChange},
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData)

    const classes = Classes("ui5-form", props.className)

    const groupByOptions = [
        { value: ActivityGroupBy.DATE,      label: 'Date' },
        { value: ActivityGroupBy.PROJECT,   label: 'Project' },
        { value: ActivityGroupBy.USER,      label: 'User' },
    ]

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectMulti form                = {form}
                                    formFieldName       = 'projects'
                                    availableProjects   = {getAvailableProjectsByViewType(props.view.type)}
                                    disabled            = {props.disabled}
                                    parentsFor          = {EntityType.PROJECT}
                                    onParentSelect      = {onParentSelect}/>

                <SelectOption label         = "Default group by"
                              form          = {form}
                              formFieldName = 'defaultGroupBy'
                              options       = {groupByOptions}
                              disabled      = {props.disabled}/>
            </div>
        </div>
    )
}
